import React from 'react';
import styled from 'styled-components';
import { Banner, Button } from '@repo/design-system';
import { space } from '@repo/design-tokens';

import type { DraftChoiceError } from './useDraftChoice';

/**
 * The action row inside an inline `Banner`, to the shipped practice the design-system epic records
 * as BUILT AHEAD OF DESIGN (`epic-design-system.md` §6B, "an inline Banner with an ACTION ROW"):
 * ghost / `xs` `Button`s in a margin-only row under the body. One place, so the draft-choice
 * consumers converge on the primitive's `actions` slot together when Rob ratifies it.
 */
export const BannerActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[2]};
  margin-top: ${space[2]};
`;

/**
 * A draft-choice failure, or an empty answer, in its tone: an error is announced assertively
 * (`role="alert"`), an empty answer — no slot, cleared by a launch — politely, because it is a fact
 * rather than a failure. *Reload* where reloading is the honest next step.
 */
const DraftChoiceErrorBanner: React.FC<{ error: DraftChoiceError; onReload: () => void }> = ({
  error,
  onReload,
}) => (
  <Banner surface="on-solid" tone={error.tone}>
    {error.message}
    {error.reload && (
      <BannerActions>
        <Button type="button" variant="ghost" size="xs" onClick={onReload}>
          Reload
        </Button>
      </BannerActions>
    )}
  </Banner>
);

export default DraftChoiceErrorBanner;
